module.exports = __webpack_public_path__ + "static/img/img-p2-6gs.c20eafc5.jpg";